import { Button } from "../../Atoms/Button";
import { Eye } from "../../Atoms/Eye";
import { Pagination } from "../../Atoms/Pagination";
import { Title } from "../../Atoms/Title";
import * as S from "./styles";
import { useProfiles } from "./useProfiles";
import { removeUnderscore } from "../../../utils/removeUnderscore";

export const ProfilesTemplates = () => {
  const {
    navigate,
    perfis,
    isMobile,
    pagination,
    setNumberPage,
    canAccessProfiles,
    canEditProfiles,
  } = useProfiles();

  return (
    <S.Container>
      <S.Wrapper>
        <Title>Perfis Cadastrados</Title>

        <S.WrapperButton>
          {canEditProfiles ? (
            <Button
              data-variant-outline
              onClick={() => navigate("/configuracoes/perfis/cadastro")}
            >
              <img src="/assets/svgs/icon-plus.svg" alt="icon plus" />
              Cadastrar
            </Button>
          ) : (
            <></>
          )}
        </S.WrapperButton>

        {canAccessProfiles && perfis?.length > 0 && (
          <S.Table>
            {perfis.map((i) => (
              <S.TableItem key={Math.random()}>
                <p>
                  NOME: <span>{removeUnderscore(i?.nome)}</span>
                </p>
                <p>
                  STATUS:{" "}
                  <span className={i?.ativo ? "ativo" : "inativo"}>
                    {i?.ativo ? "Ativo" : "Inativo"}
                  </span>
                </p>
                <div>
                  {canEditProfiles ? (
                    <Eye
                      onClick={() =>
                        navigate(`/configuracoes/perfis/detalhe?id=${i.uuid}`)
                      }
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </S.TableItem>
            ))}
          </S.Table>
        )}

        {canAccessProfiles && perfis?.length > 0 && (
          <Pagination
            maxPageNumbersDisplayed={isMobile ? 3 : 10}
            key={`${Math.random()} - ${pagination}`}
            totalPage={pagination.totalPage}
            totalRegister={pagination.totalPage}
            actualPage={pagination.actualPage}
            setNumberPage={setNumberPage}
          />
        )}
      </S.Wrapper>
    </S.Container>
  );
};
